import type { ProfileDocumentDto, ProfileDocumentKind } from '@paladin-monorepo/common';
import API, { API_URL } from '../api';

export const profileDocumentsApi = {
  async list(): Promise<ProfileDocumentDto[]> {
    return API.get<ProfileDocumentDto[]>('/me/profile/documents').then(
      (res) => res.data,
    );
  },

  async upload(file: File, kind: ProfileDocumentKind): Promise<ProfileDocumentDto> {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('kind', kind);
    return API.post<ProfileDocumentDto>('/me/profile/documents', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    }).then((res) => res.data);
  },

  async replaceFile(id: string, file: File): Promise<ProfileDocumentDto> {
    const formData = new FormData();
    formData.append('file', file);
    return API.post<ProfileDocumentDto>(
      `/me/profile/documents/${encodeURIComponent(id)}/file`,
      formData,
      { headers: { 'Content-Type': 'multipart/form-data' } },
    ).then((res) => res.data);
  },

  async reorder(documentIds: string[]): Promise<ProfileDocumentDto[]> {
    return API.patch<ProfileDocumentDto[]>('/me/profile/documents/reorder', {
      documentIds,
    }).then((res) => res.data);
  },

  async remove(id: string): Promise<void> {
    await API.delete(`/me/profile/documents/${id}`);
  },

  downloadUrl(id: string): string {
    return `${API_URL}/me/profile/documents/${id}/download`;
  },

  async downloadBlob(id: string): Promise<{ blob: Blob; filename: string }> {
    const res = await API.get<Blob>(`/me/profile/documents/${id}/download`, {
      responseType: 'blob',
    });
    const cd = res.headers['content-disposition'] as string | undefined;
    let filename = 'document';
    if (cd) {
      const m = /filename\*?=(?:UTF-8'')?["']?([^"';]+)/i.exec(cd);
      if (m?.[1]) {
        try {
          filename = decodeURIComponent(m[1].replace(/['"]/g, ''));
        } catch {
          filename = m[1];
        }
      }
    }
    return { blob: res.data, filename };
  },
};
